<template>
	<div>
		<Read/>
		<Create/>
	</div>
</template>

<script>
// @ is an alias to /src
import Read from '@/components/Video/Read.vue'
import Create from '@/components/Video/Create.vue'

export default {
  name: 'eclass-video',
  components: {
    Read,
    Create
  }
}
</script>
